import creativityBg from "./images/creativity-bg.png";
import sanyaVideo2 from "./images/Sanya-2.mp4";
import emeraldMobileBg from "./images/birthstones/emerald-mobileView.png";
import { useEffect, useRef } from "react";
import "./creativity.css";
import gsap from "gsap";
export default function Creativity() {
  let mobileRef = useRef(null);
  let imgRef_1 = useRef(null);
  let imgRef_2 = useRef(null);
  let imgRef_3 = useRef(null);

  useEffect(() => {
    gsap.from(imgRef_1, {
      y: -80,
      scrollTrigger: {
        trigger: mobileRef,
        // markers: true,
        scrub: 1
      }
    });

    gsap.from(imgRef_2, {
      y: 50,
      scrollTrigger: {
        trigger: mobileRef,
        // markers: true,
        scrub: 1
      }
    });
    gsap.from(imgRef_3, {
      y: -100,
      scrollTrigger: {
        trigger: mobileRef,
        // markers: true,
        scrub: 1
      }
    });
  });
  return (
    <div>
      <section
        className="section1 sep1"
        style={{ backgroundImage: `url(${creativityBg})` }}
      >
        <div>
          <h2 className="creativity-header">Stil</h2>
          <div className="separator1">
            <div className="separator1-item-1">
              <video
                className="videoDropthemic"
                playsInline
                autoPlay
                loop
                muted
              >
                <source
                  src="https://cdn.media.amplience.net/v/teilor/Sanya-2/mp4_720p"
                  type="video/mp4"
                />
              </video>
            </div>
          </div>
          <div className="separator1 desc">
            <div className="separator1-item-2">
              <a
                href={
                  "https://www.teilor.ro/product/5769/Inel-din-aur-galben-de-14K"
                }
              >
                <img
                  className="zoom"
                  src="https://cdn.media.amplience.net/i/teilor/4720_YELLOW_1"
                  alt="Inel din aur galben de 14K"
                />
              </a>
            </div>
            <div className="separator1-item-2">
              <a
                href={
                  "https://www.teilor.ro/product/112658/Inel-din-aur-galben-de-14K"
                }
              >
                <img
                  className="zoom"
                  src="https://cdn.media.amplience.net/i/teilor/206926_YELLOW_1"
                  alt="Inel din aur galben de 14K"
                />
              </a>
            </div>
            <div className="separator1-item-2">
              <a
                href={
                  "https://www.teilor.ro/product/5771/Inel-din-aur-galben-de-14K"
                }
              >
                <img
                  className="zoom"
                  src="https://cdn.media.amplience.net/i/teilor/4721_YELLOW_1"
                  alt=""
                />
              </a>
            </div>
          </div>
          <div className="separator1 mobileView" ref={(el) => (mobileRef = el)}>
            <div className="mobile-bg">
              <img src={emeraldMobileBg} alt="" />
            </div>
            <div className="separator1-mobil-1" ref={(el) => (imgRef_1 = el)}>
              <a
                href={
                  "https://www.teilor.ro/product/5769/Inel-din-aur-galben-de-14K"
                }
              >
                <img
                  className="zoom"
                  src="https://cdn.media.amplience.net/i/teilor/4720_YELLOW_1"
                  alt="Inel din aur galben de 14K"
                />
              </a>
            </div>
            <div className="separator1-mobil-2" ref={(el) => (imgRef_2 = el)}>
              <a
                href={
                  "https://www.teilor.ro/product/112658/Inel-din-aur-galben-de-14K"
                }
              >
                <img
                  className="zoom"
                  src="https://cdn.media.amplience.net/i/teilor/206926_YELLOW_1"
                  alt="Inel din aur galben de 14K"
                />
              </a>
            </div>
            <div className="separator1-mobil-3" ref={(el) => (imgRef_3 = el)}>
              <a
                href={
                  "https://www.teilor.ro/product/5771/Inel-din-aur-galben-de-14K"
                }
              >
                <img
                  className="zoom"
                  src="https://cdn.media.amplience.net/i/teilor/4721_YELLOW_1"
                  alt="Inel din aur galben de 14K"
                />
              </a>
            </div>
          </div>
          <div className="creativity-content">
            <div className="creativity-text">
              <p>
                Piese de aur versatile: îmbină-le și poartă-le cu atitudine în
                mix-uri diferite de design, forme și culori.
              </p>
            </div>
            <div className="cta-colectie mobile-erase">
              {" "}
              <a
                href={
                  "https://www.teilor.ro/category/urbanima?page=1&sortBy=newest&layout=standard&refinementList%5Bro_categories.lvl1%5D%5B0%5D=Bijuterii%20%3E%20Inele"
                }
              >
                <div className="button1"> DESCOPERĂ INELELE </div>
              </a>
            </div>
            <div className="col-1 mobile-reveal">
              <div className="cta-colectie">
                {" "}
                <a href="https://www.teilor.ro/category/urbanima?page=1&sortBy=newest&layout=standard&refinementList%5Bro_categories.lvl1%5D%5B0%5D=Bijuterii%20%3E%20Inele">
                  <div className="button1"> DESCOPERĂ INELELE </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
